/**
 * 참고: https://podotree.atlassian.net/wiki/spaces/kakaopagedev/pages/2948071613/Next
 */
export enum ShareType {
  /** 더보기 */
  More = 'CH00',
  KakaoTalk = 'CH01',
  Facebook = 'CH03',
  Twitter = 'CH04',
  Url = 'CH05',
}

export const KAKAOTALK_CONTENTS_HOME_VIEWER_TEMPLATE_ID = 3522;
export const KAKAOTALK_CONTENTS_HOME_VIEWER_TEMPLATE_ID_SANDBOX = 349;
export const KAKAOTALK_DEFAULT_TEMPLATE_ID = 13374;
export const KAKAOTALK_DEFAULT_TEMPLATE_ID_SANDBOX = 561;
